import React from "react";
import { Navigate, useRouteError, useNavigate } from "react-router-dom";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { ErrorBoundary as ErrorBoundaryIcon } from "src/components/icons/all/errorboundary";
import { makeStyles, useTheme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.background.default,
  },
  card: {
    padding: theme.spacing(6),
    maxWidth: 480,
    width: '100%',
    boxShadow: theme.shadows[5],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper,
  },
  icon: {
    marginBottom: theme.spacing(4),
    fontSize: 120,
    color: theme.palette.error.main,
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    color: theme.palette.error.main,
    textAlign: 'center',
  },
  message: {
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary,
    textAlign: 'center',
  },
  description: {
    marginBottom: theme.spacing(4),
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontSize: 16,
    textAlign: 'center',
  },
  button: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1.5, 4),
    fontWeight: 600,
  },
}));

export default function ErrorBoundary() {
  const error = useRouteError();
  const classes = useStyles();
  const theme = useTheme();
  const navigate = useNavigate();

  // Redirect to login for session errors
  if (error instanceof Response && (error.status === 401 || error.status === 403)) {
    return <Navigate to="/login" replace />;
  }

  // Friendly error UI for all other errors
  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <ErrorBoundaryIcon fontSize="300px" />
        <Typography variant="h4" className={classes.title}>
          Oops! Something went wrong
        </Typography>
        {/* <Typography variant="body1" className={classes.message}>
          {error?.status ? `${error.status} ${error.statusText}` : error?.message || String(error)}
        </Typography> */}
        <Typography variant="body2" className={classes.description}>
          Please try again, or return to the login page.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/login", { replace: true })}
          className={classes.button}
        >
          Go to Login
        </Button>
      </Card>
    </div>
  );
} 